// @ts-nocheck
import * as React from 'react';
import Modal from '@mui/material/Modal';
import ProgramarEnvio from './ProgramarEnvio';
import { styled } from '@mui/material/styles';
import { Button, useMediaQuery } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: "25px",
    width: 400,
    p: 4,
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
        width: '80%',
    },
}));


export default function ProgramarEnvioModal(props) {

    const { form, setForm, enviar, loading, tipoEnvio } = props
    const [open, setOpen] = React.useState(false);
    const isMobile = useMediaQuery('(max-width:960px)');
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Button sx={{ textTransform: 'none' }} variant="outlined" color="primary" onClick={handleOpen} disabled={loading}>
                {loading && tipoEnvio === 'programar' ? "Programando..." : isMobile ? "Programar" : "Programar envío"}
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Root>
                    <ProgramarEnvio
                        handleClose={handleClose}
                        form={form}
                        setForm={setForm}
                        enviar={enviar}
                    />

                </Root>
            </Modal>
        </>
    );
}
